// extracted by mini-css-extract-plugin
module.exports = {"starView":"index_starView__YECY-","view":"index_view__2iCko","star1":"index_star1__nEbY7","star2":"index_star2__2RmEu","diImg":"index_diImg__3U5-X","caiImg":"index_caiImg__3SNKN"};